import { render, staticRenderFns } from "./FormListColumnComposer.vue?vue&type=template&id=9ef8c618"
import script from "./FormListColumnComposer.vue?vue&type=script&lang=js"
export * from "./FormListColumnComposer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports